"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireWildcard(require("react"));
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _validations = _interopRequireWildcard(require("./validations"));
var _lodash = require("lodash");
var _excluded = ["onChange", "name", "value"],
  _excluded2 = ["input", "ranking_component_answers", "min_value", "max_value", "schemaHasHeading", "numberOfInputs", "hint_text", "label", "config"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var initialRankingResults = function initialRankingResults() {
  var optionsToRank = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return optionsToRank.reduce(function (acc, item) {
    acc[item.answer] = '';
    return acc;
  }, {});
};
var OptionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "ranking_component__OptionsContainer"
})(["align-items:center;display:flex;gap:1rem;"]);
var OptionRange = _styledComponents["default"].div.withConfig({
  displayName: "ranking_component__OptionRange"
})(["width:60px;min-width:60px;"]);
var RankingContainer = _styledComponents["default"].div.withConfig({
  displayName: "ranking_component__RankingContainer"
})(["display:flex;flex-direction:column;gap:8px;align-items:flex-start;& select{height:auto;min-height:50px;}"]);
var storedResponseToObject = function storedResponseToObject() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return value.reduce(function (acc, item, index) {
    acc[index + 1] = item;
    return acc;
  }, {});
};
var RankingComponent = function RankingComponent(_ref) {
  var _ref$input = _ref.input,
    onChange = _ref$input.onChange,
    name = _ref$input.name,
    value = _ref$input.value,
    rest = (0, _objectWithoutProperties2["default"])(_ref$input, _excluded),
    ranking_component_answers = _ref.ranking_component_answers,
    min_value = _ref.min_value,
    max_value = _ref.max_value,
    schemaHasHeading = _ref.schemaHasHeading,
    numberOfInputs = _ref.numberOfInputs,
    hint_text = _ref.hint_text,
    label = _ref.label,
    config = _ref.config,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  var hasExclusiveAnswers = !!config.mutually_exclusive_answers;
  var _useState = (0, _react.useState)(value && (0, _lodash.isArray)(value) ? storedResponseToObject(value) : initialRankingResults(ranking_component_answers)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    rankingResults = _useState2[0],
    setRankingResults = _useState2[1];
  var maxRankValue = (ranking_component_answers === null || ranking_component_answers === void 0 ? void 0 : ranking_component_answers.length) || 0;
  var rankingRange = (0, _react.useMemo)(function () {
    return Array.from({
      length: Number(maxRankValue)
    }, function (_, i) {
      return {
        value: i + 1,
        label: "".concat(i + 1)
      };
    });
  }, [maxRankValue]);
  var handleRankingEvent = function handleRankingEvent(key, value) {
    setRankingResults(function (prevState) {
      prevState[key] = value.toString();
      onChange(Object.assign({}, prevState));
      return prevState;
    });
  };
  (0, _react.useEffect)(function () {
    if (value === 'set_by_exclusive_input') {
      setRankingResults(initialRankingResults);
    }
  }, [value]);
  (0, _react.useEffect)(function () {
    if (value) {
      onChange(rankingResults);
    }
  }, []);
  var getValue = (0, _react.useCallback)(function (index, answerValue) {
    return Number(rankingResults[answerValue]);
  }, [rankingResults]);
  var hasError = props.meta.error && props.meta.touched;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleFieldset, {
    error: hasError,
    isExclusiveAnswer: hasExclusiveAnswers
  }, !schemaHasHeading && numberOfInputs === 1 ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
    schemaHasHeading: schemaHasHeading,
    numberOfInputs: numberOfInputs
  }, (0, _utils.stripHtml)(label)) : /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "id_".concat(name),
    className: "basic-label"
  }, (0, _utils.stripHtml)(label || '')), hint_text ? /*#__PURE__*/_react["default"].createElement(_formElements.HintText, {
    text: hint_text
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    role: "alert",
    id: "t-".concat(name, "_error-message_")
  }, hasError && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, props.meta.error)), /*#__PURE__*/_react["default"].createElement(RankingContainer, {
    id: "id_".concat(name)
  }, ranking_component_answers === null || ranking_component_answers === void 0 ? void 0 : ranking_component_answers.map(function (ranking_component_answer, index) {
    return /*#__PURE__*/_react["default"].createElement(OptionsContainer, {
      key: ranking_component_answer.identifier
    }, /*#__PURE__*/_react["default"].createElement(OptionRange, null, /*#__PURE__*/_react["default"].createElement(_formElements.SelectInput, {
      id: "ranking_".concat(name, "_").concat(index),
      inputStyle: "ehp",
      "data-test-id": "raking-component-options-".concat(ranking_component_answer.identifier),
      required: true,
      options: rankingRange,
      is_multi_select: false,
      displayPlaceHolder: false,
      convertValuesToStrings: false,
      initialValue: "",
      placeholderValue: '',
      onChange: function onChange(value) {
        handleRankingEvent(ranking_component_answer.answer, value);
      },
      "aria-label": "".concat((0, _utils.stripHtml)(label || ''), ", ").concat((0, _utils.stripHtml)(ranking_component_answer.label)),
      value: getValue(index, ranking_component_answer.answer)
    })), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "ranking_".concat(name, "_").concat(index)
    }, (0, _utils.stripHtml)(ranking_component_answer.label)));
  }))));
};
var _default = exports["default"] = RankingComponent;